import React, { FC } from 'react';
import styled from 'src/theme';
import { Row, Col, Modal } from 'antd';
import { Header } from '../parts/Header';
import { Parameters } from "./Parameters";
import { CalculationsForm } from './CalculationsForm';
import { Image } from './Image';
import { Result } from './Result';
import { ResultTable } from './ResultTable';

import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';
import generatePDF from "../../utils/generatePDF";
import {Button} from 'src/components/UI/Button'
import Copyright from "../Copyright/Copyright";

const Text = () => {
  return (
<>
      Точный расчет стоимости вашего забора будет определен нашими менеджерами после получения
      сформированной калькулятором сметы. Цены на материалы актуальны в течении трех рабочих
      дней с момента произведенного расчета, данный сметный расчет не является офертой.
</>
  );
}

export const FenceComponent: FC = () => {

  const { dispatch, fenceStore } = useStoreon<IState, IEvents>('fenceStore');

  const handleClose = () => {
    dispatch('fence/set-modal-is-open', { modalIsOpen: false });
  }

  // @ts-ignore
    return (
    <ContainerStyled>
      <Row>
        <Col xs={24}><Header children={'Калькулятор забора'}/></Col>
        <Col xs={24}><Parameters /></Col>

        <Col xs={24}>
          <Row>
            <Col xs={{ span: 24, order: 2 }} md={{ span: 11, order: 1 }}>
              <Row>
                <ColumnStyled>
                  <CalculationsForm />
                </ColumnStyled>
                <Col xs={24}>
                  <Result />
                </Col>
              </Row>
            </Col>
            <Col xs={{ span: 24, order: 1 }} md={{ span: 12, offset: 1, order: 2 }}>
              <Image />
              <TextStyled><Text /></TextStyled>
            </Col>
          </Row>
        </Col>
        <Copyright />
      </Row>
      <Modal
        title="Результаты расчета"
        centered
        visible={fenceStore.modalIsOpen}
        onCancel={handleClose}
        footer={null}
        width={1000}
        forceRender
      >
        <ResultTable />
          <Button onClick={generatePDF}>Скачать PDF</Button>
      </Modal>
    </ContainerStyled>
  );
};

const ContainerStyled = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 1660px;
  display: block;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  padding-left: 32px;
  padding-right: 32px;
  position: relative;
  @media screen and ${props => props.theme.media.tablet} {
    padding-left: 24px;
    padding-right: 24px;
  }
  @media screen and ${props => props.theme.media.mobile} {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const ColumnStyled = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 482px;
  padding: 0 10% 20px;
  background: ${props => props.theme.colors.smokeTranslucent};
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    padding: 0 15% 20px;
  }
`;

const TextStyled = styled.span`
  position: relative;
  display: flex;
  margin-top: 30px;
  margin-left: 21%;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 112%;
  letter-spacing: 0.01em;
  color: ${props => props.theme.colors.nero};
  &::before {
    content: '*';
    font-size: 14px;
    position: absolute;
    top: 3px;
    left: -8px;
    color: #212121;
  }
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    display: none;
  }
`;
